import gql from "graphql-tag"

export default gql`
  mutation ingestionSourceScan($id: String!) {
    ingestionSourceScan(id: $id)
  }
`
